'use client';

import * as React from 'react';
import { MailIcon } from 'lucide-react';
import { Badge } from '@workspace/ui/components/badge';

export function Contact(): React.JSX.Element {
  return (
    <section className="py-24 lg:py-32 min-h-[70vh] flex items-center">
      <div className="container px-6">
        <div className="mx-auto max-w-2xl text-center">
          {/* Section Header */}
          <div className="mb-8">
            <Badge className="bg-gradient-to-r from-[#4531FF]/20 to-[#00C6FF]/20 text-[#00C6FF] border border-[#4531FF]/20 rounded-full px-4 py-1 mb-4">
              <span className="text-xs font-medium">CONTACT US</span>
            </Badge>
            <h1 className="text-3xl font-normal tracking-tight text-white sm:text-4xl mb-4">
              Get in touch
            </h1>
            <p className="text-lg text-[#9EA1AE]">
              Have questions about DAIRECTOR? We're here to help.
            </p>
          </div>

          {/* Email Contact */}
          <div className="bg-[#1A1B29]/80 backdrop-blur-xl rounded-2xl border border-[#4531FF]/25 p-12 hover:border-[#00C6FF]/30 transition-all duration-300">
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#4531FF]/20 to-[#00C6FF]/20 flex items-center justify-center">
                <MailIcon className="h-8 w-8 text-[#00C6FF]" />
              </div>
            </div>
            <h2 className="text-xl font-normal mb-4 text-white">Email us directly</h2>
            <a
              href="mailto:support@dairector.ai"
              className="text-2xl text-[#00C6FF] hover:text-[#FFB457] hover:underline font-medium transition-colors"
            >
              support@dairector.ai
            </a>
            <p className="text-sm text-[#9EA1AE] mt-6">
              We typically respond within 24 hours
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}